import {
  Component,
  OnInit,
  ChangeDetectorRef, ChangeDetectionStrategy,
  ViewChild, ViewEncapsulation
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ServiceCallCreateService } from './service-call-create.service';
import { DialogHelper, ExceptionHelper, DateHelper } from './../../../../helper';
import { DatePipe } from '@angular/common';

import { TeamSummaryService } from '../../user/team-summary.service';
import { EquipmentSummaryService } from '../../equipment';
import { EcallDetailService } from '../../ecall';
import { ServiceCallDetailService } from '../service-call-detail';
import { PreventiveMaintenanceDetailService } from '../../preventive-maintenance';

import { CustomerSummaryService, CustomerSiteSummaryService } from '../../customer';
import { IsActive, ServiceCall, PMStatus } from './../../../../model';

import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { OWL_datetime_formats } from './../../owl_datetime_formats';

@Component({
  selector: 'app-service-call-create',
  templateUrl: './service-call-create.component.html',
  styleUrls: [
    '../../../../../scss/vendors/ng-select/ng-select.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
        {provide: OWL_DATE_TIME_FORMATS, useValue: OWL_datetime_formats},
  ],
})
export class ServiceCallCreateComponent implements OnInit {

  @ViewChild('successModal') successModal: any;
  @ViewChild('dangerModal') dangerModal: any;
  redirect = true;

  customers = [];
  dropdownSettingsCustomer = {};

  sites = [];
  dropdownSettings = {};
  // siteOptions: Array<IOption> = [];

  addServiceCallForm: FormGroup;

  siteId: any;
  pmId: any = null;
  ecallId: any = null;
  serviceCallId: any = null;
  customerPara: any = null;
  customerShortName: any;
  customerName: any;
  siteShortName: any;
  customerId: any;
  contactPerson: FormControl;
  contactNumber: FormControl;
  // status: FormControl;
  creationTime: FormControl;
  arrivedTime: FormControl;
  completedTime: FormControl;
  teamIds: FormControl;
  technicianIds: FormControl;
  tentativeBeginDate: FormControl;
  tentativeFinishDate: FormControl;
  serviceBeginDate: FormControl;
  serviceFinishDate: FormControl;
  // dates: FormControl;
  remarks: FormControl;
  schedule: FormControl;

  selectedCustomerName = '';
  selectedCustomerShortName = '';
  selectedSiteName = '';
  generatedStatus: number;
  dateError: Boolean = true;
  // equipmentJobNumber: store the job Number for each equipment
  //    default value = all default values for jobNumber select fields ([0]?)
  // when jobNumber select field is changed, update equipmentJobNumber[equipmentId] to be the new value
  // finally, map it with selectedIds to get those that are checked
  selectedJobNumber: any;

  teams: any[];
  teamsOptions = [];
  dropdownSettingsTeam = {};
  selectedTeams = [];
  checkedTeamNames: Array<String> = [];
  checkedTeamNums: Array<number> = [];

  technicians: any[];
  techniciansOptions = [];
  dropdownSettingsTechnician = {};
  selectedTechnicians = [];
  checkedTechnicianNames: Array<String> = [];
  checkedTechnicianNums: Array<number> = [];
  technicianListModel: Array<any> = [];

  currentTime: Date;

  url = this.router.url;
  // calledFrom: indicate which party called this component
  // 5 values: null (service call add), cu (customer shortcut link), pm (pm create followup),
  //           ec (ecall create followup), sc (service call create followup)
  calledFrom: string;

  // currentStep = 0 (service call static info)
  //             = 1 (add equipment)
  //             = 2 (review)
  currentStep: number;
  // indicate number of times the user go next / go back to different steps
  loadStepCounter: number;
  serviceCall = new ServiceCall();
  selectedEquipmentList: string[];
  selectedEquipments: string[];  // hand to API

  dataTable: any;
  equipmentList: any[];
  selectedIds: number[];
  equipmentCheckboxes = {};
  equipmentJobNumber = {};

  addServiceCallInputs: any;
  equipmentDetailListModel: Array<any> = [];
  serviceStatus = PMStatus;

  constructor(
    private dialog: DialogHelper,
    private chRef: ChangeDetectorRef,
    private exception: ExceptionHelper,
    private dateHelper: DateHelper,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private teamSummaryService: TeamSummaryService,
    private equipmentSummaryService: EquipmentSummaryService,
    private ecallDetailService: EcallDetailService,
    private serviceCallDetailService: ServiceCallDetailService,
    private preventiveMaintenanceDetailService: PreventiveMaintenanceDetailService,
    private serviceCallCreateService: ServiceCallCreateService,
    private customerSummaryService: CustomerSummaryService,
    private customerSiteSummaryService: CustomerSiteSummaryService,
    private translateService: TranslateService
  ) {
    translateService.setDefaultLang('en-us');
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      // set id values and calledFrom by identifying the router url
      if (this.url.indexOf('/cu/') !== -1) {
        // found "/cu/" in url --> customer
        this.calledFrom = 'cu';
        this.customerId = params.id;
        this.customerPara = this.customerId;
      } else if (this.url.indexOf('/pm/') !== -1) {
        // found "/pm/" in url --> pm create followup
        this.calledFrom = 'pm';
        this.pmId = params.id;
      } else if (this.url.indexOf('/ec/') !== -1) {
        // found "/ec/" in url --> ecall create followup
        this.calledFrom = 'ec';
        this.ecallId = params.id;
      } else if (this.url.indexOf('/sc/') !== -1) {
        // found "/sc/" in url --> service call create followup
        this.calledFrom = 'sc';
        this.serviceCallId = params.id;
      } else {
        // nothing found --> service call add
        this.calledFrom = null;
      }
    });

    this.currentStep = 0;
    this.loadStepCounter = 0;

    this.dropdownSettings = {
      singleSelection: true,
      text: 'Select Site',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'locationShort'
    };
    this.dropdownSettingsCustomer = {
      singleSelection: true,
      text: 'Select Customer',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'shortName'
    };

    this.dropdownSettingsTeam = {
      singleSelection: false,
      text: 'Select Team',
      enableCheckAll: false,
      enableFilterSelectAll: false,
      enableSearchFilter: true
    };

    this.dropdownSettingsTechnician = {
      singleSelection: false,
      text: 'Select Technician',
      enableSearchFilter: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All'
    };

    this.createForm();

    this.currentTime = new Date();
    this.dateError = true;

    this.checkedTeamNames = [];
    this.checkedTeamNums = [];
    this.selectedTeams = [];

    this.checkedTechnicianNames = [];
    this.checkedTechnicianNums = [];
    this.selectedTechnicians = [];

    this.selectedIds = [];

    this.getCustomerSummary();
    this.setDefaultValue();
    this.getTeamSummary();
  }

  createForm() {
    this.addServiceCallForm = this.formBuilder.group({
      customerId: new FormControl([], [
        Validators.required
      ]),
      siteId: new FormControl([], [
        Validators.required
      ]),
      contactPerson: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      contactNumber: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      // status: new FormControl('', [
      //   Validators.required
      // ]),
      creationTime: new FormControl('', [
        Validators.required
      ]),
      arrivedTime: new FormControl('', [
      ]),
      completedTime: new FormControl('', [
      ]),
      teamIds: new FormControl([], [
        Validators.required
      ]),
      technicianIds: new FormControl([], [
      ]),
      tentativeBeginDate: new FormControl('', [
      ]),
      tentativeFinishDate: new FormControl('', [
      ]),
      serviceBeginDate: new FormControl('', [
      ]),
      serviceFinishDate: new FormControl('', [
      ]),
      // dates: new FormControl('', [
      //   Validators.required
      // ]),
      remarks: new FormControl('', [
        Validators.maxLength(1000)
      ]),
      schedule: new FormControl('', [
        Validators.maxLength(1000)
      ]),
      customerReport: new FormControl('', [
        Validators.maxLength(1000)
      ]),
    });
  }

  getCustomerSummary(): void {
    this.customerSummaryService.getSummary(IsActive.active)
      .subscribe((data: any) => {
        this.customers = data.customerListModel;

        // set the customer input value only when called from customer shortcut
        // for others, no need to set it here cuz it is uneditable
        if (this.calledFrom == 'cu') {
          for (const customer of this.customers) {
            if (customer.id == this.customerId) {
              this.addServiceCallForm.controls['customerId'].setValue([customer]);
              this.selectedCustomerShortName = this.addServiceCallForm.controls['customerId'].value[0].shortName;
              this.selectedCustomerName = this.addServiceCallForm.controls['customerId'].value[0].name;
              this.getSiteSummary(customer.id);
            }
          }
        }

        $('div.c-btn').attr('id', 'single-select');
      }, error => {
        this.exception.showError(error, 'showDanModalBtn');
        this.redirect = true;
      }, () => {
        this.chRef.detectChanges();
      });
  }

  getSiteSummary(customerId): void {
    this.customerSiteSummaryService.getSummary(customerId, IsActive.active)
      .subscribe((data: any) => {
        this.sites = data.siteListModel;
        $('div.c-btn').attr('id', 'single-select');
      },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = true;
        });
  }

  getTeamSummary() {
    this.teamSummaryService.getSummary()
      .subscribe((data: any) => {
        this.teams = data;
        const options = [];
        for (const team of this.teams) {
          let option: any;
          option = { 'itemName': team.name, 'id': team.id };
          options.push(option);
        }

        this.teamsOptions = options;

        $('div.c-btn').attr('id', 'multi-select');
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  getTeamMemberSummary() {
    this.teamSummaryService.getTechnicianSummary(this.checkedTeamNums)
      .subscribe((data: any) => {
        this.technicians = data;
        const options = [];
        for (const tech of this.technicians) {
          let option: any;
          option = { 'itemName': tech.title, 'id': tech.id };
          options.push(option);
        }

        this.techniciansOptions = options;

        $('div.c-btn').attr('id', 'multi-select');
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  setDefaultValue() {
    // set default values depending on the value of calledFrom
    switch (this.calledFrom) {
      case 'pm': {
        // set customerShortName & customerName
        this.preventiveMaintenanceDetailService.getDetail(this.pmId)
          .subscribe(
            data => {
              if (data) {
                this.customerId = data.customerId;
                this.customerShortName = data.customerShortName;
                this.customerName = data.customer;
                // set customerId value and remove its validation
                this.addServiceCallForm.controls['customerId'].setValue([(this.customerShortName)]);
                this.addServiceCallForm.get('customerId').clearValidators();
                this.getSiteSummary(this.customerId);
              }
            },
            err => {
              $('.card').hide();
              this.exception.showError(err, 'showDanModalBtn');
              this.redirect = true;
            }
          );
        break;
      }
      case 'ec': {
        // set customerShortName, customerName & siteShortName
        this.ecallDetailService.getDetail(this.ecallId)
          .subscribe(
            data => {
              if (data) {
                this.customerId = data.customerId;
                this.siteId = data.siteId;
                this.customerShortName = data.customerShortName;
                this.customerName = data.customer;
                this.siteShortName = data.locationShortName;
                // set customerId value and remove its validation
                this.addServiceCallForm.controls['customerId'].setValue([(this.customerShortName)]);
                this.addServiceCallForm.get('customerId').clearValidators();
                // set siteId value and remove its validation
                this.addServiceCallForm.controls['siteId'].setValue([(this.siteShortName)]);
                this.addServiceCallForm.get('siteId').clearValidators();
              }
            },
            err => {
              $('.card').hide();
              this.exception.showError(err, 'showDanModalBtn');
              this.redirect = true;
            }
          );
        break;
      }
      case 'sc': {
        // set customerShortName, customerName & siteShortName
        this.serviceCallDetailService.getDetail(this.serviceCallId)
          .subscribe(
            data => {
              if (data) {
                this.customerId = data.customerId;
                this.siteId = data.siteId;
                this.customerShortName = data.customerShortName;
                this.customerName = data.customer;
                this.siteShortName = data.locationShortName;
                // set customerId value and remove its validation
                this.addServiceCallForm.controls['customerId'].setValue([(this.customerShortName)]);
                this.addServiceCallForm.get('customerId').clearValidators();
                // set siteId value and remove its validation
                this.addServiceCallForm.controls['siteId'].setValue([(this.siteShortName)]);
                this.addServiceCallForm.get('siteId').clearValidators();
              }
            },
            err => {
              $('.card').hide();
              this.exception.showError(err, 'showDanModalBtn');
              this.redirect = true;
            }
          );
        break;
      }
      default: {
        // for 'cu', customerId is already set in getCustomerSummary()
        break;
      }
    }
  }

  // setStatus(): void {
  //   this.selectedStatus = $('#status').val();
  // }

  // checkTeam() {
  //   if (!this.crac && !this.admin && !this.ubs) {
  //     // all unchecked
  //     this.noCheckboxChecked = true;
  //     this.noCheckboxTouched = false;
  //   } else {
  //     this.noCheckboxChecked = false;
  //   }
  // }
  selectAll(event): void {
    this.equipmentList.forEach(equipment => {
      if (event.target.checked) {
        this.equipmentCheckboxes[equipment.equipmentId] = true;
        if (!this.selectedIds.includes(equipment.equipmentId)) {
          this.selectedIds.push(equipment.equipmentId);
        }
      } else {
        this.equipmentCheckboxes = {};
        this.selectedIds.length = 0;
      }
    });
  }

  goToAddEquipment(addServiceCallForm): void {
    this.getInput(addServiceCallForm);
    if (this.loadStepCounter === 0) {
      this.getEquipmentSummaryForInitialization();
    } else {
      this.getEquipmentSummary();
    }
    this.currentStep++;
    this.loadStepCounter++;
  }

  public getInput(addServiceCallForm): any {
    if (this.calledFrom != 'pm' && this.calledFrom != 'ec' && this.calledFrom != 'sc') {
      // if it is normal input case, get from user input
      this.customerId = addServiceCallForm.controls.customerId.value[0].id;
    } else if (this.calledFrom == 'pm' || this.calledFrom == 'ec' || this.calledFrom == 'sc') {
      // if it is readonly case, set the values shown on review page
      this.selectedCustomerShortName = this.customerShortName;
      this.selectedCustomerName = this.customerName;
    }
    this.serviceCall.customerId = this.customerId;

    if (this.calledFrom != 'ec' && this.calledFrom != 'sc') {
      this.siteId = addServiceCallForm.controls.siteId.value[0].id;
    } else if (this.calledFrom == 'ec' || this.calledFrom == 'sc') {
      this.selectedSiteName = this.siteShortName;
    }
    // this.serviceCall.customerId = addServiceCallForm.controls.customerId.value[0].id;
    this.serviceCall.siteId = this.siteId;

    this.serviceCall.contactPerson = addServiceCallForm.controls.contactPerson.value;
    this.serviceCall.contactNumber = addServiceCallForm.controls.contactNumber.value;
    this.serviceCall.status = this.generatedStatus;
    this.serviceCall.creationTime = this.datePipe.transform(addServiceCallForm.controls.creationTime.value, 'yyyy-MM-dd HH:mm:ss');
    this.serviceCall.arrivedTime = this.datePipe.transform(addServiceCallForm.controls.arrivedTime.value, 'yyyy-MM-dd HH:mm:ss');
    this.serviceCall.completedTime = this.datePipe.transform(addServiceCallForm.controls.completedTime.value, 'yyyy-MM-dd HH:mm:ss');
    this.serviceCall.tentativeBeginDate =
      this.datePipe.transform(addServiceCallForm.controls.tentativeBeginDate.value, 'yyyy-MM-dd HH:mm:ss');
    this.serviceCall.tentativeFinishDate =
      this.datePipe.transform(addServiceCallForm.controls.tentativeFinishDate.value, 'yyyy-MM-dd HH:mm:ss');
    this.serviceCall.serviceBeginDate =
      this.datePipe.transform(addServiceCallForm.controls.serviceBeginDate.value, 'yyyy-MM-dd HH:mm:ss');
    this.serviceCall.serviceFinishDate =
      this.datePipe.transform(addServiceCallForm.controls.serviceFinishDate.value, 'yyyy-MM-dd HH:mm:ss');
    this.pushTeamsArray();
    this.serviceCall.teamIds = this.checkedTeamNums;
    this.pushTechniciansArray();
    this.serviceCall.remarks = addServiceCallForm.controls.remarks.value;
    this.serviceCall.schedule = addServiceCallForm.controls.schedule.value;
    this.serviceCall.customerReport = addServiceCallForm.controls.customerReport.value;
  }

  pushTeamsArray(): void {
    this.checkedTeamNames = [];
    this.checkedTeamNums = [];
    for (const team of this.selectedTeams) {
      this.checkedTeamNames.push(team.itemName);
      this.checkedTeamNums.push(team.id);
    }
  }

  pushTechniciansArray(): void {
    this.checkedTechnicianNames = [];
    this.checkedTechnicianNums = [];
    for (const technician of this.selectedTechnicians) {
      this.checkedTechnicianNames.push(technician.itemName);
      this.checkedTechnicianNums.push(technician.id);
    }
  }

  dateTimeChange(ele: any) {

    if (ele.input.id === 'tentativeBeginDate') {
      // this.addServiceCallForm.controls['status'].setValue(PMStatus.arranging);
      this.generatedStatus = PMStatus.arranging;

      this.addServiceCallForm.controls['serviceBeginDate'].setValue(null);
      this.addServiceCallForm.controls['serviceFinishDate'].setValue(null);

      this.tentativeBeginDate = this.addServiceCallForm.controls['tentativeBeginDate'].value;
    } else if (ele.input.id === 'tentativeFinishDate') {
      // this.addServiceCallForm.controls['status'].setValue(PMStatus.arranging);
      this.generatedStatus = PMStatus.arranging;

      this.addServiceCallForm.controls['serviceBeginDate'].setValue(null);
      this.addServiceCallForm.controls['serviceFinishDate'].setValue(null);
    } else if (ele.input.id === 'serviceBeginDate') {
      // this.addServiceCallForm.controls['status'].setValue(PMStatus.confirmed);
      this.generatedStatus = PMStatus.confirmed;

      this.addServiceCallForm.controls['tentativeBeginDate'].setValue(null);
      this.addServiceCallForm.controls['tentativeFinishDate'].setValue(null);

      this.serviceBeginDate = this.addServiceCallForm.controls['serviceBeginDate'].value;
    } else if (ele.input.id === 'serviceFinishDate') {
      // this.addServiceCallForm.controls['status'].setValue(PMStatus.confirmed);
      this.generatedStatus = PMStatus.confirmed;

      this.addServiceCallForm.controls['tentativeBeginDate'].setValue(null);
      this.addServiceCallForm.controls['tentativeFinishDate'].setValue(null);
    }


    if (!this.addServiceCallForm.controls['tentativeBeginDate'].value &&
        !this.addServiceCallForm.controls['serviceBeginDate'].value) {
      this.dateError = true;
    }  else {
      this.dateError = false;
    }

  }

  public onClose(items: any) {
    if (this.addServiceCallForm.value.siteId.length === 0) {
      this.addServiceCallForm.controls['siteId'].setErrors({ 'required': true });
    }
    if (this.addServiceCallForm.value.customerId.length === 0) {
      this.addServiceCallForm.controls['customerId'].setErrors({ 'required': true });
    }
  }

  onSiteSelect(item: any) {
    this.selectedSiteName = item.locationShort;
    // clear selected equipments when site is changed
    this.selectedIds = [];
    this.equipmentCheckboxes = {};
    this.equipmentJobNumber = {};
    // reset the load step counter so that the initialization of equipmentJobNumber will be executed
    this.loadStepCounter = 0;
  }

  onCustomerSelect(item: any) {
    this.customerId = item.id;
    // clear site input
    this.addServiceCallForm.controls['siteId'].setValue([]);
    // get customer site summary
    if (this.customerId) {
      this.getSiteSummary(this.customerId);
    }
    this.selectedCustomerName = item.name;
    this.selectedCustomerShortName = item.shortName;
  }

  onCustomerDeselect(item: any) {
    // clear site input
    this.addServiceCallForm.controls['siteId'].setValue([]);
    // clear site options
    this.sites = [];
  }

  onTeamSelect(item: any) {
    this.pushTeamsArray();
    this.getTeamMemberSummary();
  }

  onTeamDeselect(item: any) {
    this.pushTeamsArray();
    // clear technicians input
    this.addServiceCallForm.controls['technicianIds'].setValue([]);
    if (this.checkedTeamNums.length == 0) {
      // if no team is selected, clear technicians options
      this.techniciansOptions = [];
    } else {
      // else re-get technician list
      this.getTeamMemberSummary();
    }
  }

  goBack() {
    this.currentStep--;
    if (this.currentStep === 1) {
      this.getEquipmentSummary();
    }
    this.loadStepCounter++;
  }

  goToReview() {
    this.currentStep++;
    this.getSelectedEquipmentSummary();
    interface EquipmentDetailModel {
      equipmentId: number;
      jobNumber: string;
      isActive: number;
    }
    // clear equipmentModel
    this.equipmentDetailListModel = [];
    for (const equipmentId of this.selectedIds) {
      // create an equipmentDetailModel for this selected equipment
      const tempModel: EquipmentDetailModel = { equipmentId: equipmentId, jobNumber: this.equipmentJobNumber[equipmentId], isActive: 1 };
      this.equipmentDetailListModel.push(tempModel);
    }

    interface TechnicianModel {
      userId: number;
      isActive: number;
    }
    // clear technicianListModel
    this.technicianListModel = [];
    for (const technicianNum of this.checkedTechnicianNums) {
      // create an technicianModel for this selected equipment
      const tempModel: TechnicianModel = { userId: technicianNum, isActive: 1 };
      this.technicianListModel.push(tempModel);
    }

    this.createInput();
    this.loadStepCounter++;
  }

  // this is only for loading add equipment page for the first time
  getEquipmentSummaryForInitialization(): void {
    this.equipmentSummaryService
      .getSummary(this.siteId, null, IsActive.active)
      .subscribe((data: any) => {
        if ($.fn.dataTable.isDataTable('#serviceCallEquipmentDataTables')) {
          $('#serviceCallEquipmentDataTables').DataTable().destroy();
        }

        this.equipmentList = data.equipmentListModel;

        // initialize equipmentJobNumber to be the default value of select input (jobNumbers[0])
        for (const equipment of this.equipmentList) {
          if (equipment.jobNumbers) {
            this.equipmentJobNumber[equipment.equipmentId] = equipment.jobNumbers[0];
          }
        }

        this.chRef.detectChanges();

        const table: any = $('#serviceCallEquipmentDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  getEquipmentSummary(): void {
    this.equipmentSummaryService
      .getSummary(this.siteId, null, IsActive.active)
      .subscribe((data: any) => {
        if ($.fn.dataTable.isDataTable('#serviceCallEquipmentDataTables')) {
          $('#serviceCallEquipmentDataTables').DataTable().destroy();
        }

        this.equipmentList = data.equipmentListModel;
        this.chRef.detectChanges();

        const table: any = $('#serviceCallEquipmentDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  selectEquipment(event): void {
    if (event.srcElement.checked === true) {  // checkbox checked
      this.selectedIds.push(Number(event.srcElement.id));
    } else if (event.srcElement.checked === false) {  // checkbox unchecked
      const removeIndex: number = this.selectedIds.indexOf(Number(event.srcElement.id));
      if (removeIndex !== -1) {
        this.selectedIds.splice(removeIndex, 1);
      }
    }
  }

  onJobNumberSelect(item: any) {
    this.equipmentJobNumber[item.srcElement.id] = item.srcElement.value;
  }

  getSelectedEquipmentSummary(): void {
    this.equipmentSummaryService
      .getSummaryByIds(this.selectedIds)
      .subscribe((data: any) => {
        if ($.fn.dataTable.isDataTable('#selectedEquipmentDataTables')) {
          $('#selectedEquipmentDataTables').DataTable().destroy();
        }

        this.selectedEquipmentList = data.equipmentListModel;
        this.chRef.detectChanges();

        const table: any = $('#selectedEquipmentDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  createInput() {
    this.addServiceCallInputs = {
      // creationTime: this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss'),
      creationTime: this.serviceCall.creationTime,
      arrivedTime: this.serviceCall.arrivedTime,
      completedTime: this.serviceCall.completedTime,
      tentativeBeginDate: this.serviceCall.tentativeBeginDate,
      tentativeFinishDate: this.serviceCall.tentativeFinishDate,
      serviceBeginDate: this.serviceCall.serviceBeginDate,
      serviceFinishDate: this.serviceCall.serviceFinishDate,
      // status: Number(this.serviceCall.status),
      status: this.serviceCall.status,
      remarks: this.serviceCall.remarks,
      schedule: this.serviceCall.schedule,
      contactPerson: this.serviceCall.contactPerson,
      contactNumber: this.serviceCall.contactNumber,
      siteId: this.serviceCall.siteId,
      customerId: this.serviceCall.customerId,
      teamIds: this.serviceCall.teamIds,
      userAssignModels: this.technicianListModel,
      equipList: this.equipmentDetailListModel,
      ecallId: (this.ecallId == null ? null : Number(this.ecallId)),
      pmServiceId: (this.pmId == null ? null : Number(this.pmId)),
      relatedServiceCallId: (this.serviceCallId == null ? null : Number(this.serviceCallId)),
      customerReport: this.serviceCall.customerReport
    };
  }

  addServiceCall(): void {
    this.serviceCallCreateService
      .create(this.addServiceCallInputs)
      .subscribe(
        data => {
          if (data) {
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;
        }
      );
  }

  closeSuccessModel() {
    this.back();
  }

  back(): void {
    switch (this.calledFrom) {
      case 'cu':
        this.router.navigate(['/home/service/summary/' + this.customerPara]);
        break;

      case 'pm':
        this.router.navigate(['/home/preventive-maintenance/detail/' + this.pmId]);
        break;

      case 'ec':
        this.router.navigate(['/home/e-call/detail/' + this.ecallId]);
        break;

      case 'sc':
        this.router.navigate(['/home/service/detail/' + this.serviceCallId]);
        break;

      default:
        this.router.navigate(['/home/service']);
        break;
    }
  }

  continue() {
    this.successModal.hide();
    // this.router.navigateByUrl('/home/service', { skipLocationChange: true }).then(() =>
    //   this.router.navigate(['home/service/add']));
    this.router.navigate([this.router.url]);
    this.ngOnInit();
  }

  errorClose() {
    if (this.redirect) {
      this.back();
    }
    else {
      this.dangerModal.hide();
    }

  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-create/service-call-create.component.ts